import { render, staticRenderFns } from "./DialogItensLancamento.vue?vue&type=template&id=2f548636&"
import script from "./DialogItensLancamento.vue?vue&type=script&lang=js&"
export * from "./DialogItensLancamento.vue?vue&type=script&lang=js&"
import style0 from "./DialogItensLancamento.vue?vue&type=style&index=0&id=2f548636&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports